import AlgoliaSearchBox from '../algoliaSearchBox/AlgoliaSearchBox';

const initAlgoliaSearchBox = (searchFormId: string) => {
  const searchForm = document.getElementById(searchFormId);

  if (searchForm !== null) {
    AlgoliaSearchBox.init(searchForm);
  }
};

export default initAlgoliaSearchBox;

